import * as z from "zod";

export const archiveReturnsOnboarding = {
  name: "archiveReturnsOnboarding" as const,
  input: z.object({}),
  output: z.object({}),
};
